import styles from "./PageLoader.module.css";
import { useLanguage } from "../context/LanguageContext";

export default function PageLoader({ label = "Loading..." }) {
  const { translateStatic: ts } = useLanguage();

  return (
    <div className={styles.shell} role="status" aria-live="polite">
      <div className={styles.mark} aria-hidden="true">
        <span />
      </div>
      <p>{ts(label)}</p>
    </div>
  );
}
